<template>
  <div 
    class="DesktopNavWrapper absolute xl:relative bg-bc-gray-bg"
    :style="cssProps"
  >
    <ul 
      class="LeftNav"
    >
      <slot></slot>
    </ul>
  </div>
</template>

<script>
import elementsBoxModel from '../../elementsBoxModel'
import useBcMenu from '@/frontapp/store/bcMenu'
import { mapStores } from 'pinia'

export default {
  props: {},
  data() {
    return {}
  },
  computed: {
    cssProps() {
      return {
        '--min-el-offset-top': this.minElOffsetTop + 'px',
      };
    },
    minElOffsetTop() {
      return elementsBoxModel.heroBanner.height + elementsBoxModel.breadcrumbs.height
    },
    ...mapStores(useBcMenu)
  },
  methods: {
    clickOutsideEvent(event) {
      if (!(this.$el === event.target || this.$el.contains(event.target))) {
        this.bcMenuStore.closeDesktopNavMenu()
      }
    }
  },
  mounted() {
    document.body.addEventListener('mousedown', this.clickOutsideEvent)
  },
  provide() {
    return {
      addNavStep: (id) => {
        this.steps.push(id)
      },
      openNavStep: (title, icon, id) => {
        this.openedItems.push({ title, icon, id })
      },
      openedNavStepIds: [],
    }
  },
  unmounted() {
    document.body.removeEventListener('mousedown', this.clickOutsideEvent)
  }
};
</script>

<style lang="scss">
.DesktopNavWrapperOverlay, .DesktopNavWrapper {
  @screen md {
    left: -0.875rem;
    top: -1rem;
    padding-top: 1rem;
    padding-left: 0.875rem;
    z-index: 511;
    width: 2.625rem;
  }

  @screen xl {
    left: -1.1875rem;
    top: -1.25rem;
    padding-top: 1rem;
    padding-left: 1.1875rem;
    width: auto;
  }
}
</style>
